import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@chakra-ui/react';
import { useAppContext } from '../../../context/appContext';
import { E_INVOICE_FORM_ID } from '../constants/eInvoice';
import FormField from './FormField';

const EInvoice = () => {
  const { t } = useTranslation();
  const { einvoiceCarrier } = useAppContext();
  const handleClick = () =>
    document.getElementById(E_INVOICE_FORM_ID)?.submit();

  if (!einvoiceCarrier.enabled) {
    return null;
  }
  return (
    <FormField label={t('users.invoice_carrier')}>
      <Box mt="9px" textAlign="left">
        <Button
          variant="textButton"
          className="member-center-profile__text-button"
          onClick={handleClick}
          data-e2e-id="member-center-profile-e-invoice_button"
        >
          {t('users.electronic_invoice_carrier')}
        </Button>
      </Box>
    </FormField>
  );
};

export default EInvoice;
